
import {
  Utensils,
  Coffee,
  Wine,
  Hotel,
  Sparkles,
  Scissors,
  Heart,
  ShoppingBag,
  Dumbbell,
  Stethoscope,
  GraduationCap,
  MoreHorizontal,
} from "lucide-react";

export const GetIndustryIcon = (industryType: string) => {
  switch (industryType) {
    case "restaurant":
      return <Utensils className="w-3 h-3" />;
    case "cafe":
      return <Coffee className="w-3 h-3" />;
    case "bar":
    case "nightclub":
      return <Wine className="w-3 h-3" />;
    case "hotel":
      return <Hotel className="w-3 h-3" />;
    case "spa":
    case "massage_therapy":
      return <Sparkles className="w-3 h-3" />;
    case "salon":
    case "beauty":
      return <Scissors className="w-3 h-3" />;
    case "tattoo":
      return <Heart className="w-3 h-3" />;
    case "retail":
      return <ShoppingBag className="w-3 h-3" />;
    case "fitness":
      return <Dumbbell className="w-3 h-3" />;
    case "healthcare":
      return <Stethoscope className="w-3 h-3" />;
    case "education":
      return <GraduationCap className="w-3 h-3" />;
    default:
      return <MoreHorizontal className="w-3 h-3" />;
  }
};

export const getIndustryColor = (industryType: string) => {
  switch (industryType) {
    case "restaurant":
      return "text-orange-600 bg-orange-50 border-orange-200";
    case "cafe":
      return "text-amber-600 bg-amber-50 border-amber-200";
    case "bar":
    case "nightclub":
      return "text-purple-600 bg-purple-50 border-purple-200";
    case "hotel":
      return "text-blue-600 bg-blue-50 border-blue-200";
    case "spa":
    case "massage_therapy":
      return "text-emerald-600 bg-emerald-50 border-emerald-200";
    case "salon":
    case "beauty":
      return "text-pink-600 bg-pink-50 border-pink-200";
    case "tattoo":
      return "text-red-600 bg-red-50 border-red-200";
    case "retail":
      return "text-indigo-600 bg-indigo-50 border-indigo-200";
    case "fitness":
      return "text-green-600 bg-green-50 border-green-200";
    case "healthcare":
      return "text-teal-600 bg-teal-50 border-teal-200";
    case "education":
      return "text-violet-600 bg-violet-50 border-violet-200";
    default:
      return "text-gray-600 bg-gray-50 border-gray-200";
  }
};
